import {UserErrorsFactory} from '../../user/Errors/factory.js'
import UserServicesFactory from '../../user/Services/factory.js'
import ProductsErrorsFactory from '../Errors/factory.js'
import ProductsRepositoryFactory from '../Repositories/factory.js'
import GetAdProductsUseCase from './GetAdProductsUseCase.js'
import GetPaymentAdProductsUseCase from './GetPaymentAdProductsUseCase.js'
import GetVisibilityProductsUseCase from './GetVisibilityProductsUseCase.js'

export default class ProductstUseCasesFactory {
  static getVisibilityProductsUseCase = ({config}) =>
    new GetVisibilityProductsUseCase({
      repository: ProductsRepositoryFactory.hTTPProductsRepository({
        config
      }),
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      }),
      getVisibilityProductsError: ProductsErrorsFactory.getVisibilityProductsError
    })

  static getPaymentAdProductsUseCase = ({config}) =>
    new GetPaymentAdProductsUseCase({
      repository: ProductsRepositoryFactory.hTTPProductsRepository({
        config
      }),
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      }),
      getPaymentAdProductsError: ProductsErrorsFactory.getPaymentAdProductsError
    })

  static getAdProductsUseCase = ({config}) =>
    new GetAdProductsUseCase({
      repository: ProductsRepositoryFactory.hTTPProductsRepository({
        config
      }),
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      }),
      getAdProductsError: UserErrorsFactory.getAdProductsError
    })
}
